﻿import controller from '../../../../Resources/Scripts/_Shared/controller';
import { ssnValidation, organisationValidation, emailValidation, zipcodeValidation, phoneNumberValidation } from '../../BookingFlowPage/Scripts/Validation';

function myAimoParkForm(context) {
  const country = document.querySelector('html').getAttribute('country');
  const fieldsets = Array.prototype.slice.call(context.querySelectorAll('fieldset'));
  const saveButton = context.querySelector('button');
  const messageSuccess = context.querySelector('.myaimoparksettings__form__success-message');
  const messageError = context.querySelector('.myaimoparksettings__form__error-message');
  const recordType = context.querySelector('input[name = "RecordType"]').value;
  let formElements = [];

  const checkbox = document.getElementById('ShippingSameAsBillingAddress');
  let shippingSameAsBillingAddress = checkbox.value === 'True' ? true : false;
  const shippingElements = context.querySelectorAll('[name^=Shipping]');
  const billingElements = context.querySelectorAll('[name^=Billing]');

  const disableFields = (shippingSameAsBillingAddress) => {
    for (let i = 1; i < shippingElements.length; i++) {
      shippingElements[i].disabled = shippingSameAsBillingAddress;
    }
  }

  const copyBillingInformationToShipping = () => {
    for (let i = 1; i < shippingElements.length; i++) {
      if (shippingElements[i].value != billingElements[i - 1].value) {
        shippingElements[i].value = billingElements[i - 1].value;
        if (shippingElements[i].type === 'select-one') shippingElements[i].dispatchEvent(new Event('change'));
      }
    }
  }

  checkbox.addEventListener('click', () => {
    shippingSameAsBillingAddress = checkbox.value.toLowerCase() === 'true' ? false : true;
    checkbox.value = shippingSameAsBillingAddress.toString();
    checkbox.checked = shippingSameAsBillingAddress;
    disableFields(shippingSameAsBillingAddress);
    if (shippingSameAsBillingAddress) copyBillingInformationToShipping();
  });

  const invoiceEmailHandler = () => {
    const radioButtons = context.querySelectorAll('.radio input[name="Invoice_Method__c"]');
    const emailInputWrapper = context.querySelector('.invoiceemail');
    const emailInput = context.querySelector('.invoiceemail input');
    const setDisplay = (choice) => emailInputWrapper.style.display = choice;

    emailInput.addEventListener("blur", () => emailInput.classList.remove("exception"));

    radioButtons.forEach(button => {
      if (button.checked && button.value != "EMAIL") setDisplay("none");
      if (button.checked && button.value === "EMAIL") {
        setDisplay("block");
        emailInput.required = true;
        emailInputWrapper.previousElementSibling.classList.add("noborder");
      }
      button.addEventListener('change', (e) => {
          if (button.checked && e.target.value != "EMAIL") {
          setDisplay("none");
          emailInput.removeAttribute("required");
          emailInputWrapper.previousElementSibling.classList.remove("noborder");
        } else {
          setDisplay("block");
          emailInput.required = true;
          emailInputWrapper.previousElementSibling.classList.add("noborder");
          if (!emailInput.value) emailInput.classList.add("exception");
          emailInput.focus();
        }
      });
    });
  }

  function init() {
    if (fieldsets.length === 0)
      return;

    if (shippingSameAsBillingAddress) {
      copyBillingInformationToShipping();
      disableFields(shippingSameAsBillingAddress);
    }

    invoiceEmailHandler();
    //notificationEmailHandler();

    fieldsets.forEach(fieldset => {
      const elements = identifyFieldsetElement(fieldset);

      if (elements)
        formElements = [...formElements, ...elements];
    })

    context.addEventListener('submit', onSubmitHandler);
  }

	function identifyFieldsetElement(fieldset) {
    const textElements = fieldset.querySelectorAll('input[type="text"], input[type="password"], input[type="ssn"], input[type="email"], input[type="organisation"], textarea');
    if (textElements.length > 0)
      return Array.prototype.slice.call(textElements).map(element => {
        element.addEventListener('keyup', isFormChanged);
        element.setAttribute('data-original-value', element.value);
        return { type: 'text', element, changed: false, valid: true };
      });

    const radioElements = fieldset.querySelectorAll('input[type="radio"]');
    if (radioElements.length > 0)
      return Array.prototype.slice.call(radioElements).map(element => {
        element.addEventListener('change', isFormChanged);
        element.setAttribute('data-original-value', element.checked);
        return { type: 'radio', element, changed: false, valid: true };
      });

    const selectElements = fieldset.querySelectorAll('select');
    if (selectElements.length > 0)
      return Array.prototype.slice.call(selectElements).map(element => {
        element.addEventListener('change', isFormChanged);
        element.setAttribute('data-original-value', element.value);
        return { type: 'select', element, changed: false, valid: true };
      });

    const checkboxElements = fieldset.querySelectorAll('input[type="checkbox"]');
    if (checkboxElements.length > 0)
      return Array.prototype.slice.call(checkboxElements).map(element => {
        element.addEventListener('change', isFormChanged);
        element.setAttribute('data-original-value', element.checked);
        return { type: 'checkbox', element, changed: false, valid: true };
      });

    return null;
	}

  function isFieldValid(element) {
    const dataType = element.dataset.type;

    if ((element.required ?? false) && element.value?.length === 0) {
      return false;
    }
    else if (dataType === 'email' && element.value.length > 0) {
      if (!emailValidation(element.value) || !element.checkValidity())
        return false;
    }
    else if (dataType === 'ssn' && element.value.length > 0) {
      if (!ssnValidation(element.value, country) || !element.checkValidity())
        return false;
    }
    else if (dataType === 'organisation' && element.value.length > 0) {
      if (!organisationValidation(element.value, country) || !element.checkValidity())
        return false;
    }
    else if (dataType === 'zipcode' && element.value.length > 0) {
      if (!zipcodeValidation(element.value, country) || !element.checkValidity())
        return false;
    }
    else if (dataType === 'phone' && element.value.length > 0) {
      if (!phoneNumberValidation(element.value) || !element.checkValidity())
        return false;
    }

    return true;
  }

  function isFormChanged() {
    const changedElements = formElements.map(item => {
      let isElementChanged = false;
      const originalValue = item.element.dataset.originalValue ?? '';
      const isRequired = item.element.required ?? false;
      const isValid = isFieldValid(item.element);

      if (item.element.name.includes('Billing') && item.element.name != "ShippingSameAsBillingAddress" && shippingSameAsBillingAddress) {
        copyBillingInformationToShipping();
      }

      if ((item.type === 'text') && item.element.value !== originalValue) {
        isElementChanged = true;
      }

      if ((item.type === 'radio' || item.type === 'checkbox') && item.element.checked !== JSON.parse(originalValue.toLowerCase()))
        isElementChanged = true;

      if ((item.type === 'select') && item.element.value !== originalValue) {
        isElementChanged = true;
      }
      if (isValid) {
        item.element.classList.remove('error', 'error--required', 'error--other');
      } else {
        item.element.classList.add('error');

        if (isRequired && item.element.value?.length === 0) {
          item.element.classList.add('error--required');
          item.element.classList.remove('error--other');
        } else {
          item.element.classList.add('error--other');
          item.element.classList.remove('error--required');
        }
      }

      return { ...item, changed: isElementChanged, valid: isValid }
    }).filter(item => item.changed && item.valid);

    //console.log('changedElements', changedElements)
    //console.log(context.querySelectorAll('.error'))

    if (changedElements.length > 0 && context.checkValidity() && context.querySelectorAll('.error').length === 0) {
      messageError.classList.remove('myaimoparksettings__form__error-message--visible');
      messageSuccess.classList.remove('myaimoparksettings__form__success-message--visible');
      saveButton.removeAttribute('disabled');

      if (window.location.hash)
        history.replaceState(null, document.title, window.location.pathname + window.location.search);
    }
    else {
      saveButton.setAttribute('disabled', 'disabled');
    }  
  }

  function resetFormValues() {
    formElements.forEach(item => {
      if (!item.element.dataset.originalValue)
        return;

      if (item.type === 'text')
        item.element.setAttribute('data-original-value', item.element.value)

      if (item.type === 'radio' || item.type === 'checkbox')
        item.element.checked ? item.element.setAttribute('data-original-value', 'true') : item.element.setAttribute('data-original-value', 'false');
    });

    saveButton.setAttribute('disabled', 'disabled');
    saveButton.removeAttribute('aria-busy');
  }

  async function onSubmitHandler(e) {

    if (typeof window.FormData === 'undefined') return true;
    e.preventDefault();
    if (!context.checkValidity() || context.querySelectorAll('.error').length > 0) 
      return;
    
    saveButton.setAttribute('disabled', 'disabled');
    saveButton.setAttribute('aria-busy', 'true');
    messageError.classList.remove('myaimoparksettings__form__error-message--visible');
    messageSuccess.classList.remove('myaimoparksettings__form__success-message--visible');

    var formData = new FormData(context);
    var url = context.getAttribute('action');

    var request = new XMLHttpRequest();
    request.onreadystatechange = function() {
      if (this.readyState !== 4) return;

      if (this.status !== 200) {
        messageError.classList.add('myaimoparksettings__form__error-message--visible');
        saveButton.removeAttribute('disabled');
        saveButton.removeAttribute('aria-busy');
        return;
      }

      messageSuccess.classList.add('myaimoparksettings__form__success-message--visible');
      resetFormValues();
    };
    request.open('POST', url, true);
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    request.send(formData);
  }

  return {
    init
  };
}

controller.add('myaimopark-form', myAimoParkForm);